import Vue from "vue";
import VueRouter from "vue-router";
import Arrivals from "../pages/Arrivals.vue";
import store from "../store/ApplicationStore";
import Login from "../pages/Login.vue";
import AuthCallback from "../pages/AuthCallback.vue";
import RidersPage from "../pages/Riders.vue";
import RidersWithoutTrackers from "../pages/RidersWithoutTrackers.vue";
import TrackersPage from "../pages/Trackers.vue";
import UsersPage from "../pages/Users.vue";
import ChangePasswordPage from "../pages/ChangePassword.vue";
import PageNotFound from "../pages/PageNotFound.vue";
import Race from "../pages/Race.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: () => {
      // This will be called after auth check in beforeEach
      return { name: "races" };
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/races",
    name: "races",
    component: Race,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/arrivals",
    name: "arrivals",
    component: Arrivals,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/riders/:uuid?",
    name: "riders",
    component: RidersPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/riders-without-trackers",
    name: "ridersWithoutTrackers",
    component: RidersWithoutTrackers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/trackers/:uuid?",
    name: "trackers",
    component: TrackersPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/change_password",
    name: "change_password",
    component: ChangePasswordPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "users",
    component: UsersPage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/callback",
    name: "callback",
    component: AuthCallback,
    meta: {
      hideNav: true,
    },
  },
  {
    path: "*",
    name: "notFound",
    component: PageNotFound,
    meta: {
      hideNav: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  // base: "",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.state.auth.logged_in) {
      next();
      return;
    }
    next("/login");
  } else {
    // If going to login page but already logged in, redirect to races
    if (to.path === "/login" && store.state.auth.logged_in) {
      next({ name: "races" });
      return;
    }
    next();
  }
});

export default router;
